<span data-testid="component-chip" [ngClass]="classes()" [style.min-width.px]="width()">
  <ng-content></ng-content>

  {{ label() }}

  @if (canRemove()) {
    <button data-testid="component-chip-remove" type="button" class="close" (click)="remove.emit()" [ariaLabel]="'Remove Item'">
      <mat-icon>close</mat-icon>
    </button>
  }
</span>
